








































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

@Component
export default class ClientsTable extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @typesModule.Getter('clientStatusTypes') private clientStatusTypes!: Array<ClientStatusType>;
    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;

    @Prop({ required: true }) private clients!: Array<ClientAccount>;
    @Prop({ required: true }) private page!: number;
    @Prop({ required: true }) private pageSize!: number;
    @Prop({ required: true }) private total!: number;
    @Prop({ required: true }) private emptyText!: string;

    private currentPage: number = this.page;

    public get clientFields(): Array<{}> {
        const fields = [
            { key: 'accountNo', label: 'Account No' },
            { key: 'firstName', label: 'First Name' },
            { key: 'lastName', label: 'Surname' },
            { key: 'dateOfBirth', label: 'Date of Birth' },
            { key: 'accountStatus', label: 'Account Status' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'originalSource', label: 'Introducer' },
            { key: 'address', label: 'Address' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];

        return fields;
    }

    public get paginationDescription(): string {
        const start = (this.clients.length < 1)
            ? 0
            : ((this.currentPage - 1) * this.pageSize) + 1;

        const end = start + this.pageSize > this.total
            ? this.total
            : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    @Watch('page')
    private onPageChanged(page: number): void {
        this.currentPage = page;
    }

    @Watch('currentPage')
    private onCurrentPageChanged(): void {
        this.$emit('page-changed', this.currentPage);
    }

    private getAccountStatus(accountStatusId: string): string {
        const type = this.clientStatusTypes.find((t) => t.id === accountStatusId);
        return type == null ? '' : type.value;
    }

    private getOriginalSource(originalSourceId: string): string {
        const type = this.clientOriginalSourceTypes.find((t) => t.id === originalSourceId);
        return type == null ? '' : type.value;
    }
}

